import './_flex-globals.js';

import 'unic-sc-flex/source/assets/js/helpers/namespace.js';
import 'unic-sc-flex/source/assets/js/helpers/module.js';
import 'unic-sc-flex/source/assets/js/helpers/events.js';

import 'jquery-placeholder/jquery.placeholder.js';
import 'jquery-validation/dist/jquery.validate.js';
import 'jquery-validation-unobtrusive/dist/jquery.validate.unobtrusive.js';

// jquery-ui/ui/core.js is a deprecated AMD-only shim (unconditional `define([...])`)
// that fails outside an AMD loader. Inline what the shim was supposed to load —
// each submodule has a proper `typeof define === "function"` UMD guard and falls
// back to the `jQuery` global that _flex-globals.js has already established.
// (IE-era submodules form.js, ie.js, safe-active-element.js, safe-blur.js were
// removed in jquery-ui 1.14; they are not needed in modern browsers.)
import 'jquery-ui/ui/version.js';
import 'jquery-ui/ui/jquery-patch.js';
import 'jquery-ui/ui/data.js';
import 'jquery-ui/ui/disable-selection.js';
import 'jquery-ui/ui/focusable.js';
import 'jquery-ui/ui/keycode.js';
import 'jquery-ui/ui/labels.js';
import 'jquery-ui/ui/plugin.js';
import 'jquery-ui/ui/scroll-parent.js';
import 'jquery-ui/ui/tabbable.js';
import 'jquery-ui/ui/unique-id.js';

// LLB-customized copies of unic-sc-flex form/datepicker modules — preserve display:flex
// visibility instead of letting the upstream modules overwrite it with display:block.
import '../../modules/flexforms/form.js';
import '../../modules/flexforms/datepicker.js';

import 'unic-sc-flex/source/modules/tooltips/tooltips.js';
import 'unic-sc-flex/source/modules/inputfields/fileinput.js';
import 'unic-sc-flex/source/modules/autocomplete/_autocomplete.js';
import 'unic-sc-flex/source/modules/rangefield/rangefield.js';

import 'unic-sc-flex/source/assets/js/helpers/init.js';

// LLBOKWEB-3630 — jQuery 3.x's $(document).on('ready', fn) does NOT fire
// retroactively. If the flex bundle finishes evaluating after DOMContentLoaded
// (cached pages, deferred load, slow head), unic-sc-flex's helpers/init.js
// would silently miss the ready event and no flexform/flexdatepicker/etc.
// instances get constructed — observed as dependent fields no longer toggling
// visibility because Module.prototype._initDependentFields is never reached.
// The handler is idempotent — for each [data-init] element it calls $.fn[pluginName].apply($this),
// and the plugin guards re-init via $this.data(name + '-instance') (see module.js lines 103–113). 
// So a second real ready is harmless.
jQuery(function () {
  jQuery(document).trigger('ready');
});
